import { createFileRoute, Navigate } from "@tanstack/react-router";
import { z } from "zod";
import { useAuth } from "@/hooks/useAuth";
import { RegionListing } from "@/components/regions/RegionListing";

const regionsSearchSchema = z.object({
  page: z.number().catch(1),
  pageSize: z.number().catch(50),
  search: z.string().optional(),
});

export const Route = createFileRoute("/(protected)/_layout/_org/regions")({
  validateSearch: (search) => regionsSearchSchema.parse(search),
  component: RegionsTab,
});

function RegionsTab() {
  const { hasPermission, isLoading } = useAuth();

  if (!isLoading && !hasPermission("region:read")) {
    return (
      <Navigate
        to="/unauthorized"
        search={{
          reason: "permission_denied",
          from: "/regions",
          requiredPermission: "region:read",
        }}
        replace
      />
    );
  }

  return <RegionListing />;
}
